import { UseQueryOptions } from 'react-query'
import { useCallback, useMemo } from 'react'
import { useToast } from '@chakra-ui/react'
import { QueryKey } from '../../constants/queryKey'
import { useSavedSearchesQuery } from '../../api/gqlaxy/gql/generated/graphql-hooks'
import { graphqlGLClient } from '../../api/gqlaxy/gql/queries/graphQLClient'
import { SavedSearchesQuery, SavedSearchesQueryVariables } from '../../api/gqlaxy/gql/generated/graphql'

interface ErrorPrompt {
  error: string
  message: string
}

interface Option<D, E> extends UseQueryOptions<D, E> {
  disableErrorPrompts?: boolean
  errorPrompts?: ErrorPrompt[]
}

export const useGetSavedSearches = (
  params: SavedSearchesQueryVariables,
  option: Option<SavedSearchesQuery, Error> = {
    queryKey: QueryKey.GetSavedSearches as any
  }
) => {
  const toast = useToast()

  const client = graphqlGLClient({
    // endpoint: 'http://127.0.0.1:5001/mobile-staging-376418/us-central1/gqlactus' // local endpoint
  })

  const { disableErrorPrompts, errorPrompts, ...options } = option

  const handleError = useCallback(
    (...args) => {
      const [e] = args

      if (disableErrorPrompts) return

      const prompt = errorPrompts?.find(({ error }) => error === e.message)
      const message = prompt?.message ?? e.message

      toast({
        description: message,
        status: 'error',
        duration: 8500
      })
    },
    [disableErrorPrompts, errorPrompts, options, toast]
  )

  return useSavedSearchesQuery(
    client,
    { input: { clientId: params.input.clientId } },
    {
      queryKey: QueryKey.GetSavedSearches,
      onError: handleError,
      keepPreviousData: true,
      ...options
    }
  )
}
